module.exports = __webpack_public_path__ + "media/images/placeholders/category-ffe515ea62c0422af2edf619ec4fecef.png";